import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";

export default function KnownRegNumberFields({data, handlers}) {

    return (
        <div className="row known-reg-num-block">

            {/* Registration number */}

            <ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 "
                labelText="Registration number"
                required={true}
                controlName="vanRegistrationNumber"
                value={data.vanRegistrationNumber}
                onChange={handlers.onControlChange}
                inputAttrs={{
                    maxLength: 50
                }}
            />

            {/* Van's make and model */}

            {/*<ScrollableTextBoxBlock
                containerCssClass="col-12 py-3 "
                labelText="Van's make and model"
                required={false}
                controlName="vanMakeAndModel"
                value={data.vanMakeAndModel}
                onChange={handlers.onControlChange}
                inputAttrs={{
                    maxLength: 50
                }}
            />*/}

            {/* Estimated van value */}

            {/*<ScrollableTextBoxBlock
                type="number"
                containerCssClass="col-12 py-3 "
                labelText="Estimated van value"
                required={false}
                controlName="vanEstimatedValue"
                value={data.vanEstimatedValue}
                onChange={handlers.onControlChange}
                inputAttrs={{
                    maxLength: 50
                }}
            />*/}


        </div>
    );

}